










import 'vue-awesome/icons/regular/plus-square'
import 'vue-awesome/icons/regular/minus-square'
require('./treemap.js') # treemap
Currency = require 'models/currency.coffee'

export default
  name: 'categories_treemap'
  props: ['subtypes', 'categories']
  data: ->
    all_opened: false
  computed:
    subcategories: -> _.flatten(_.compact(_.map(@categories.categories, 'subcategories')))
    can_toggle_subcategories: ->
      if @categories.categories.length > 1
        @subcategories.length > 0
      else
        @all_opened = true
        false
    has_categories_to_display: -> @categories.categories.length > 1 || @subcategories.length > 1
  mounted: -> @$nextTick => @drawTreemap()
  beforeDestroy: ->
    $(@$el).off('mouseover').off('mouseleave')
  watch:
    categories: -> @$nextTick => @drawTreemap()
    all_opened: -> @drawTreemap()
    has_categories_to_display: -> @$nextTick => @drawTreemap()
  methods:
    drawTreemap: ->
      return unless @has_categories_to_display
      $el = $(@$el)

      categories = []
      @categories.categories.forEach (cat) =>
        subcategories = [ cat ]
        if @all_opened && cat.subcategories
          subcategories = cat.subcategories
        for cat in subcategories
          color = "rgba(94, 187, 94, #{cat.percentage / 100})" if @subtypes == 'incomes'
          color = "rgba(149, 0, 0, #{cat.percentage / 100})"   if @subtypes == 'expenses'
          tooltip = cat.category + "<br/><small>" + Currency.format({value: cat.sum, color: false}) + "</small>"
          if cat.percentage < 3
            treemap_label = cat.category
          else
            treemap_label = tooltip
          categories.push [ "<div class='treemap_label' data-tr_ids='#{cat.transaction_ids}'>#{treemap_label}<div class='tooltip'>#{tooltip}<br>#{cat.percentage}%</div></div>", Math.abs(cat.sum), color ]

      heading = _.capitalize(@$t(@subtypes)) + ' ' + Currency.format({value: @categories.total, color: true, sign: 'force'})

      $target = $el.find(".treemap-#{@subtypes}")
      $target.html('')
      @$nextTick =>
        $(document).treemap $el.innerWidth(), 200,
          target    : $target
          getData   : => [ [ heading, categories ] ]
          sort      : true
          headHeight: 24

        $el.find('.treemapCell .treemapCell').click (event) =>
          tr_ids = $(event.currentTarget).find('.treemap_label').data('tr_ids') + ''
          tr_ids = _.map tr_ids.split(','), (id) -> parseInt(id)
          @$store.commit 'TRANSACTIONS/PREVIEW', tr_ids
        $el.find('.treemapCell .treemapCell').mousemove (event) ->
          $(this).find('.tooltip').css
            top : event.clientY + 5
            left: event.clientX + 5

